import { i18nextNL } from '@hvcgroep/design-system';

export default {
  "translation": {
    ...i18nextNL.translation,
    navbar: {
      close: 'Sluit menu',
      open: 'Menu',
      contact: 'Contact',
      logout: 'Uitloggen',
      overview: 'Overzicht',
      usage: 'Meterstanden',
      invoices: 'Facturen',
      myDetails: 'Mijn gegevens',
      logo: 'HVC: energie en hergebruik',
    },
    invoiceTable: {
      table: {
        headers: {
          id: 'Factuurnummer',
          creationDate: 'Datum',
          totalAmount: 'Bedrag',
          dueAmount: 'Openstaand',
          status: 'Betaalstatus',
        },
        status: {
          open: 'Openstaand',
          paid: 'Betaald',
        },
      },
      noInvoicesFound: 'U heeft nog geen facturen ontvangen.',
      invoicesError: 'Er zijn geen facturen gevonden.',
    },
    meterReadsTable: {
      error: 'Er is iets misgegaan bij het ophalen van de meterstanden. Probeer de pagina opnieuw te verversen.',
      table: {
        headers: {
          startDate: 'Datum',
          endReading: 'Stand',
          readingMethod: 'Herkomst',
          meterNumber: 'Meternummer',
        }
      },
      noMeterReadsFound: 'Er zijn geen meterstanden gevonden.',
    },
    advancePayment: {
      yourAdvancePayment: 'Uw huidige termijnbedrag',
      adjustAdvancePayment: 'Termijnbedrag wijzigen',
      iban: 'IBAN',
      amendPaymentDetails: 'IBAN of incassomoment wijzigen',
      currentAmount: 'Huidige termijnbedrag'
    },
    messages: {
      closeMessage: 'Sluit bericht',
    },
    pages: {
      overview: {
        title: 'Overzicht',
        advancePaymentExplanation: 'U betaalt elke maand een vast bedrag vooruit. Op de jaarnota verrekenen we dit met wat u echt heeft verbruikt.',
        adjustmentsTwoOrZero: 'U kunt uw termijnbedrag maximaal twee keer per jaar aanpassen tot aan uw volgende jaarnota.',
        adjustmentsOne: 'U kunt uw termijnbedrag nog één keer aanpassen tot aan uw volgende jaarnota.',
        viewAllInvoices: 'Bekijk alle facturen',
        deliveryAddress: 'Leveradres',
        viewContractDetails: 'Bekijk contractgegevens',
        message: 'U kunt nu uw meterstand doorgeven',
        submitMeterReadings: 'Meterstanden doorgeven',
        toolTipMessage: "U kunt maximaal twee keer per jaar uw termijnbedrag wijzingen",
        contractDatePassed: "Uw contract op deze aansluiting is niet meer actief. U kunt uw termijnbedrag niet meer aanpassen",
      },
      usage: {
        title: 'Meterstanden',
        viewContractDetails: 'Meer over mijn aansluiting',
        yourConnection: 'Mijn aansluiting',
        text: 'Wilt u meer informatie over uw aansluiting?',
        submitMeterReadings: 'Meterstanden doorgeven',
        species: {
          SmartMeterReading: 'Slimme meterstand',
          PhysicalReading: 'Fysieke opname',
          CustomerReading: 'Meterstand klant',
          EstimatedReading: 'Berekende meterstand',
        },
      },
      submitMeterReadings: {
        title: 'Meterstanden doorgeven',
        faqTitle: 'Veelgestelde vragen over meterstanden',
        gas: 'gas',
        warmte: 'warmte',
        noReadingRequired: 'Op dit moment verwachten wij geen meterstanden van je.',
        toOverview: 'Terug naar overzicht',
        form: {
          date: {
            label: 'Datum opname',
            error: {
              required: 'Je moet een datum invullen',
            }
          },
          meterReading: {
            label: 'Meterstand',
            description: 'Vul de meterstand in met één tot drie cijfers achter de komma.',
            unit: 'GJ',
            error: {
              required: 'Je moet een meterstand invullen',
              min: 'Je moet een meterstand invullen boven {{ min }}',
              max: 'Je moet een meterstand invullen onder {{ max }}',
              range: 'Op basis van uw verbruik in voorgaande jaren verwachtten wij een stand tussen {{ min }} en {{ max }}. De stand die u heeft ingevuld wijkt hiervan af. Kunt u controleren of de meterstand klopt?',            }
          },
          acceptedWarning: {
            error: {
              required: 'U kunt pas verder als u dit bevestigd heeft.',
              checkbox: 'Ik heb de door mij ingevulde meterstand gecontroleerd en deze is juist.',
            },
          },
          messages: {
            success: 'Uw meterstand is verstuurd. Het kan enkele minuten duren voordat deze zichtbaar is in onderstaande tabel',
            error: 'Er ging iets mis, uw meterstand is niet verstuurd. Probeer het later nogmaals.',
          },
          submit: 'Versturen',
          previousReading: 'De laatst doorgegeven stand is <0>{{ reading }}</0> op {{ date }}'
        },
      },
      invoices: {
        title: 'Facturen',
        invoiceCount_one: '{{ count }} nota',
        invoiceCount_other: '{{ count }} nota\'s',
        changeInstallmentAmountTwice: 'U kunt maximaal twee keer per jaar uw termijnbedrag wijzigen.',
      },
      changeAdvancePayment: {
        title: 'Termijnbedrag wijzigen',
        content: 'Uw termijnbedrag is een vooruitbetaling. Aan het einde van het jaar verrekenen we dit met uw werkelijke verbruik. Te veel betaald? Dan krijgt u geld terug. Andersom geldt hetzelfde: als u te weinig hebt betaald, brengen we de extra kosten in rekening.',
        amendmentDeadline: 'U kunt uw termijnbedrag nog {{ budgetBillCounter }}  keer aanpassen tot {{ deadline }}.',
        label: 'Termijnbedrag',
        saveChanges: 'Wijzigingen opslaan',
        reset: 'Terugzetten',
        cannotChangeAdvancePayment: 'U kunt uw termijnbedrag niet meer aanpassen.',
        back: 'Terug naar overzicht',
        error: {
          required: 'U moet een bedrag invullen',
          min: 'U moet een bedrag invullen boven € {{ min }}',
          max: 'U moet een bedrag invullen onder € {{ max }}',
        },
        messages: {
          success: "Uw termijnbedrag is gewijzigd. Let op: Het kan enkele minuten duren voordat de aanpassing te zien is.",
          error: "Helaas, er is iets misgegaan bij het wijzigen van uw termijnbedrag. Probeer het opnieuw."
        }
      },
      logIn: {
        title: 'Mijn hvc energie',
        logInDescription: 'Log in op Mijn HVC Energie en bekijk uw verbruik, facturen en contractgegevens eenvoudig op één plek.',
        toLoginPage: 'naar inlogpagina'
      },
      myDetails: {
        title: 'Mijn gegevens',
        customerDetails: 'Klantgegevens',
        contract: 'Contract',
        connection: 'Aansluiting',
        smartMeter: 'Slimme meter',
        hasSmartMeter: {
          true: 'Ja',
          false: 'Nee'
        },
        capacityTariff: 'Tapwaterklasse',
        capacityTariffCodes: {
          CW3: 'CW3 (6,0 liter per minuut)',
          CW4: 'CW4 (7,5 liter per minuut)',
          CW5: 'CW5 (Meer dan 9,0 liter per minuut)',
          CW6: 'CW6 (Meer dan 9,0 liter per minuut)',
          GT: 'Geen tapwater',
          ZW: 'Zonder tapwater',
        },
        standardPeriodQuantities: 'Standaard jaarverbruik',
        status: 'Status',
        statuses: {
          ACTIVE: 'Actief',
          PENDING: 'Moet nog actief worden',
          END: 'Beëindigd',
        },
        contractId: 'Contractnummer',
        downloadContract: 'Contract downloaden',
        startDate: 'Startdatum',
        endDate: 'Einddatum',
        content: {
          textCurrentRates: 'U heeft voor warmte een variabel contract waarvan de tarieven ieder jaar per 1 januari wijzigen. <0>Bekijk de huidige tarieven</0>.'
        },
      },
      contact: {
        title: 'Contact',
        content: {
          checkFaq: 'Heeft u een vraag? Kijk dan eerst tussen de veelgestelde vragen. Misschien hebben we uw vraag al eens beantwoord.',
          contactTelNumber: '0800-0700',
          contactTel: 'Staat uw vraag er niet tussen of heeft u een andere vraag? Neem dan contact op met onze klantenservice. Op werkdagen tussen 08.30 en 17.00 uur zijn wij telefonisch bereikbaar via <0>0800-0700</0> (optie 2), of bekijk <1>hier</1> de andere contactmogelijkheden.',
          contactMore: 'https://www.hvcgroep.nl/ons-verhaal/klantenservice'
        },
        faqTitle: 'Veelgestelde vragen over warmte',
        faqLink: 'https://www.hvcgroep.nl/zelf-regelen/veelgestelde-vragen',
        faqButton: 'Veelgestelde vragen',
      },
      notFound: {
        title: 'Pagina niet gevonden...',
        subTitle: 'Sorry, we kunnen de pagina niet vinden.',
        button: {
          link: '/',
          title: 'Naar overzicht',
        }
      },
      serverError: {
        title: 'Server error...',
        subTitle: 'Er ging iets mis op onze server. Probeer het later opnieuw.',
        button: {
          link: '/',
          title: 'Naar overzicht',
        }
      },
      changePaymentDetails: {
        title: 'Betaalgegevens wijzigen',
        ibanLabel: 'IBAN',
        ibanPlaceholder: 'NL00 BANK 0123 4567 89',
        submitLabel: 'Wijzigingen opslaan',
        paymentMethodLabel: 'Betaalmethode',
        automatedPayment: 'Automatische incasso',
        ideal: 'iDEAL',
        manualPayment: 'Handmatige overboeking',
        paymentCollectionLabel: 'Datum van afschrijving',
        billingCycle1: 'Datum van afschrijving rond de 15de van de maand',
        billingCycle8: 'Datum van afschrijving rond de 22ste van de maand',
        billingCycle15: 'Datum van afschrijving rond de 29ste van de maand',
        billingCycle22: 'Datum van afschrijving rond de 6de van de volgende maand',
        guidingText: "We zetten uw nota 14 dagen voordat het bedrag wordt afgeschreven voor u klaar.",
        error: {
          required: "Vul uw IBAN nummer in.",
          invalidIban: "Vul een geldig IBAN nummer in.",
        },
        messages: {
          success: "Uw betaalgegevens zijn gewijzigd. Let op: Het kan enkele minuten duren voordat de aanpassing te zien is.",
          error: "Helaas, er is iets misgegaan bij het wijzigen van uw betaalgegevens. Probeer het opnieuw."
        },
        notEditable: {
          iban: 'Het is niet langer mogelijk om uw IBAN aan te passen.',
          paymentMethod: 'Het is niet langer mogelijk om uw betaalmethode aan te passen.',
          collectionMoment: 'Het is niet langer mogelijk om uw incassomoment aan te passen.',
          paymentDetails: 'Wijziging van uw betalingsgegevens is op dit moment niet mogelijk.',
        },
      },
    },
    faq: {
      error: 'Er is een fout opgetreden bij het ophalen van de veelgestelde vragen.',
      empty: 'Er zijn geen veelgestelde vragen gevonden.',
    },
    contractSwitcher: {
      deliveryAddress: 'Leveradres',
    },
    general: {
      siteTitle: 'HVC mijn omgeving'
    },
    customerDetails: {
      name: 'Naam',
      email: 'E-mail',
      phone: 'Telefoonnummer',
      iban: 'IBAN',
    },
  },
};
